import * as Yup from 'yup';

export const FacilityDetailsValidationSchema = Yup.object().shape({
    halReference: Yup.string().nullable().required('HAL Facility Id is required.'),
    name: Yup.string().nullable().required('Name is required.'),
    contactDetails: Yup.string().nullable().required('Direct Contact Number is required.').min(10, 'Direct Contact Number must be at least 10 characters.'),
    streetAddressLine1: Yup.string().nullable().required('Address is required.'),
    suburb: Yup.string().nullable().required('Suburb is required.'),
    state: Yup.string().nullable().required('State is required.'),
    postcode: Yup.string().nullable().required('Postcode is required.'),
});

export const FacilityOpenDatesValidationSchema = Yup.object().shape({
    openFromDate: Yup.date().nullable().required('Start date is required or invalid'),
    shutDownDate: Yup.date()
        .nullable()
        .required('End date is required or invalid')
        .when('openFromDate', (openFromDate, schema) => {
            if (openFromDate) {
                const date = new Date(openFromDate);
                date.setDate(openFromDate.getDate() + 1);
                return schema.min(date, 'End date must be greater than start date');
            }
        }),
});

export const FacilityCloseDateValidationSchema = Yup.object().shape({
    closureDate: Yup.date().nullable().required('Date is required or is invalid'),
});

export const FacilityDropoffTimeSettingValidationSchema = Yup.object().shape({
    startTimeOfDropOffWindow: Yup.string().nullable().required('First dropoff time is required.'),
    endTimeOfDropOffWindow: Yup.string().nullable().required('Last dropoff time is required.'),
    timeIntervalInMinutes: Yup.string().nullable().required('Interval time is required.'),
});

export const FacilityWaitlistValidationSchema = Yup.object().shape({
    pdrRatio: Yup.number()
        .integer('Ratio needs to be a whole number')
        .min(1, 'Ratio needs to be min of 1')
        .required('Ratio is required.'),
    ptpRatio: Yup.number()
        .integer('Ratio needs to be a whole number')
        .min(1, 'Ratio needs to be min of 1')
        .required('Ratio is required.'),
    conRatio: Yup.number()
        .integer('Ratio needs to be a whole number')
        .min(1, 'Ratio needs to be min of 1')
        .required('Ratio is required.'),
    waitlistEndDate: Yup.date().required('Required.'),
});

export const RepairTypes = {
    PDR: 'PDR',
    PTP: 'PTP',
    CON: 'CON',
};

export const BusinessValidationWarningTypes = {
    CapacityLowerThanBookings: 'Capacity is lower than existing number of bookings',
    BookingsFallOutsideRepairSeason: 'One or more existing bookings fall outside repair season',
    BookingsExistOnClosedDay: 'One or more bookings have been made on the closed day',
};
